import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import * as styles from './NewLocation.scss';
var NewLocationSummary = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewLocationSummary, _Component);

  var _super = _createSuper(NewLocationSummary);

  function NewLocationSummary() {
    var _this;

    _classCallCheck(this, NewLocationSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (title, amount) {
      var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var subtext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItemWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.summaryItemTitle
      }, title), /*#__PURE__*/React.createElement("span", {
        className: styles.summaryItemAmount
      }, subtract && /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: 4
        }
      }, "-"), amount)), subtext && /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItemSecondary
      }, subtext));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFinePrintItem", function (text) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItemWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.finePrintText
      }, text)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderClientDetailView", function () {
      var _this$props = _this.props,
          clientDetails = _this$props.clientDetails,
          formValues = _this$props.formValues,
          contractInfo = _this$props.contractInfo,
          orgConfig = _this$props.orgConfig,
          totals = _this$props.totals;
      var hasExistingLicenses = contractInfo && contractInfo.totals && contractInfo.totals.clientsUsed < contractInfo.totals.clientsPermitted;
      var partnerName = contractInfo ? contractInfo.contract.businessName : 'Partner';
      var newLocationName = clientDetails && clientDetails.organization_name ? clientDetails.organization_name : 'New Location';

      var licenseFeeRendering = _this.renderItem('License Fee', _this.formatCurrency(orgConfig.managementFee));

      var adsAmountRendering = _this.renderItem('Monthly Ads Amount', _this.formatCurrency(orgConfig.adsBudget));

      var partnerCharges = orgConfig && orgConfig.locationBillingInfo && (orgConfig.locationBillingInfo.ads.billTo === 'partner' || orgConfig.locationBillingInfo.licenseFee.billTo === 'partner');
      var locationCharges = orgConfig && orgConfig.locationBillingInfo && (orgConfig.locationBillingInfo.ads.billTo === 'location' || orgConfig.locationBillingInfo.licenseFee.billTo === 'location');
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.summaryTopWrap
      }, partnerCharges && /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, partnerName, " Charges"), orgConfig.locationBillingInfo.licenseFee.billTo === 'partner' && licenseFeeRendering, orgConfig.locationBillingInfo.ads.billTo === 'partner' && adsAmountRendering), locationCharges && /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, newLocationName, " Charges"), orgConfig.locationBillingInfo.licenseFee.billTo === 'location' && licenseFeeRendering, orgConfig.locationBillingInfo.ads.billTo === 'location' && adsAmountRendering), /*#__PURE__*/React.createElement("section", {
        className: "".concat(styles.summarySection, " ").concat(styles.totalSection)
      }, _this.renderItem('Total Monthly Charge', orgConfig.locationBillingInfo.licenseFee.billTo === 'existing' ? _this.formatCurrency(parseInt(orgConfig.adsBudget, 10)) : _this.formatCurrency(parseInt(orgConfig.managementFee, 10) + parseInt(orgConfig.adsBudget, 10))))), !_this.props.edit && locationCharges && /*#__PURE__*/React.createElement("section", {
        className: "".concat(styles.summarySection, " ").concat(styles.finePrintSection)
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 16
        }
      }, _this.renderFinePrintItem("".concat(newLocationName, "'s credit card will be charged on the ").concat(moment().format('Do'), " of each month.")))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNewLocationView", function () {
      var _this$props2 = _this.props,
          contractInfo = _this$props2.contractInfo,
          formValues = _this$props2.formValues,
          orgConfig = _this$props2.orgConfig,
          totals = _this$props2.totals;
      var partnerName = contractInfo ? contractInfo.contract.businessName : 'Partner';
      var newLocationName = formValues && formValues.orgDetails.businessName && formValues.orgDetails.businessName !== '' ? formValues.orgDetails.businessName : 'New Location';

      var licenseFeeRendering = _this.renderItem('License Fee', _this.formatCurrency(orgConfig.managementFee));

      var adsAmountRendering = _this.renderItem('Monthly Ads Amount', _this.formatCurrency(orgConfig.adsBudget));

      var partnerCharges = formValues.locationBillingInfo.licenseFeeBillTo === 'partner' || formValues.locationBillingInfo.adsBillTo === 'partner';
      var locationCharges = formValues.locationBillingInfo.licenseFeeBillTo === 'location' || formValues.locationBillingInfo.adsBillTo === 'location';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.summaryTopWrap
      }, partnerCharges && /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, partnerName, " Charges"), formValues.locationBillingInfo.licenseFeeBillTo === 'partner' && licenseFeeRendering, formValues.locationBillingInfo.adsBillTo === 'partner' && adsAmountRendering), locationCharges && /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, newLocationName, " Charges"), formValues.locationBillingInfo.licenseFeeBillTo === 'location' && licenseFeeRendering, formValues.locationBillingInfo.adsBillTo === 'location' && adsAmountRendering), /*#__PURE__*/React.createElement("section", {
        className: "".concat(styles.summarySection, " ").concat(styles.totalSection)
      }, _this.renderItem('Total Monthly Charge', formValues.locationBillingInfo.licenseFeeBillTo === 'existing' ? _this.formatCurrency(parseInt(orgConfig.adsBudget, 10)) : _this.formatCurrency(parseInt(orgConfig.managementFee, 10) + parseInt(orgConfig.adsBudget, 10))))), !_this.props.edit && locationCharges && /*#__PURE__*/React.createElement("section", {
        className: "".concat(styles.summarySection, " ").concat(styles.finePrintSection)
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 16
        }
      }, _this.renderFinePrintItem("".concat(newLocationName, "'s credit card will be charged on the ").concat(moment().format('Do'), " of each month.")))));
    });

    return _this;
  }

  _createClass(NewLocationSummary, [{
    key: "render",
    value: function render() {
      var _wrapStyle = {};
      var wrapStyle = Object.assign({}, _wrapStyle, this.props.wrapStyle);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.summaryWrap,
        style: wrapStyle
      }, this.props.clientDetailView ? this.renderClientDetailView() : this.renderNewLocationView());
    }
  }]);

  return NewLocationSummary;
}(Component)) || _class);
export { NewLocationSummary as default };
NewLocationSummary.defaultProps = {
  clientDetailView: false
};